import update from 'react-addons-update'
import without from 'lodash/without'
import omit from 'lodash/omit'

import {
  QA_SERVICINGS_SUCCESS,
  DELETE_QA_SERVICING_SUCCESS
} from '../actions/qa-servicings'

import {
  DELETE_QA_WORK_ORDER_SUCCESS
} from '../actions/qa-work-orders'

export default function (state = {}, action) {
  switch (action.type) {
    case DELETE_QA_WORK_ORDER_SUCCESS:
      return omit(state, action.payload.resourceId)

    case QA_SERVICINGS_SUCCESS:
      return update(state, {
        [action.payload.qaWorkOrderId]: {
          qaServicings: { $set: action.payload.result }
        }
      })

    case DELETE_QA_SERVICING_SUCCESS:
      Object.keys(state).forEach(qaWorkOrderId => {
        const qaWorkOrder = state[qaWorkOrderId]
        const updatedQAServicings = without(qaWorkOrder.qaServicings, action.payload.resourceId)

        state = update(state, {
          [qaWorkOrderId]: {
            qaServicings: { $set: updatedQAServicings }
          }
        })
      })

      return state

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/qa-work-orders.js